import * as React from 'react';
import { Field } from 'redux-form';

import type { SaleFormViewModel } from 'ab-viewModels/sale/saleForm.viewModel';

import { SegmentLabel } from '@acceligentllc/storybook';

import Dropdown from 'af-fields/Dropdown';
import Input from 'af-fields/Input';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

type Props = {
	findSales: () => Promise<SaleFormViewModel[]>;
	isDisabled: boolean;
	salesRef: React.RefObject<Nullable<HTMLDivElement>>;
};

const SalesSection: React.FC<Props> = (props) => {
	const { findSales, isDisabled, salesRef } = props;
	const [sales, setSales] = React.useState<SaleFormViewModel[]>([]);

	const renderSalesMenuItem = React.useCallback(
		(_sale: SaleFormViewModel) =>
			<div className={styles['job-form__contact-dropdown-item']} key={_sale.id}>
				<div className={styles['job-form__contact-dropdown-item__main']}>
					{_sale.fullName}
				</div>
				<div className={styles['job-form__contact-dropdown-item__secondary']}>
					{_sale.title}
				</div>
			</div>,
		[]);

	const renderSelectedSalesLead = React.useCallback((_sale: SaleFormViewModel) => _sale.fullName, []);

	const lazyLoadSaleLeads = React.useCallback(async (isLazyLoaded: boolean) => {
		if (!isLazyLoaded) {
			const fetchedSales = await findSales();
			setSales(fetchedSales);
		}
	}, [findSales]);

	return (
		<div className={formSectionClass} ref={salesRef}>
			<SegmentLabel
				label="Sales"
				tooltip="Overview of the sales record associated with this entry, including identification, assigned lead, and estimated value."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="salesId"
						label="Sales ID"
						name={JobUpsertFM.getAttributeName('salesId')}
						placeholder="Enter Sales ID"
						type="text"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Dropdown}
						disabled={isDisabled}
						id="salesLeadId"
						label="Sales Lead"
						name={JobUpsertFM.getAttributeName('salesLeadId')}
						onLazyLoad={lazyLoadSaleLeads}
						options={sales}
						placeholder="Select Sales Lead"
						propName="salesLead"
						renderMenuItem={renderSalesMenuItem}
						renderSelected={renderSelectedSalesLead}
						valueKey="id"
						withCaret={true}
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						addonAfter="$"
						component={Input}
						disabled={isDisabled}
						id="estimateTotal"
						isZeroIfEmpty={true}
						label="Estimate Total"
						name={JobUpsertFM.getAttributeName('estimateTotal')}
						type="number"
						withThousandsSeparator={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(SalesSection);
